import { Box, useTheme } from "@mui/material";
import moment from "moment";
import { tokens } from "../theme";
import { timeFormat } from "../utils/constants";
import { getTimeZoneAbbreviation } from "../utils/dateUtils";

// Browser zone is fixed for the session; resolve the abbreviation once.
const TIME_ZONE_ABBR = getTimeZoneAbbreviation();

// APIs return UTC instants; utc().local() converts even when the "Z" suffix is
// missing. Date on top, time + zone below, so narrow columns never truncate.
const TimeCell = ({ value }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const [date, time] = value
    ? moment.utc(value).local().format(timeFormat).split(", ")
    : ["—"];
  return (
    <Box sx={{ lineHeight: 1.35 }}>
      <Box>{date}</Box>
      {time ? (
        <Box
          sx={{ fontSize: 11, color: colors.grey[400] }}
        >{`${time} ${TIME_ZONE_ABBR}`}</Box>
      ) : null}
    </Box>
  );
};

export default TimeCell;
